import { MetalCaratOptions, MetalColorOptions } from '../../utils/predefineTypes.js/constant'
import DiamondClarity from '../../views/diamond-clarity/DiamondClarity.vue'

export default {
  /* -------------------------------------------------------------------------- */
  /*                          Category Dropdown Values                          */
  /* -------------------------------------------------------------------------- */
  loading: false,
  listLoading: false,
  categoryOptions: [],
  SubCategoryList: [],
  SizeList: [],
  diamondConstantList: [],
  DiamondList: [],
  RoleList: [],
  DiamondClarityList: [],
}
